import { ref, readonly } from 'vue';
import { KIOSK_KEY_STORAGE_KEY } from '@/constants';

const readStoredKey = (): string | null => {
  try {
    return globalThis.localStorage?.getItem(KIOSK_KEY_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
};

const kioskKeyRef = ref<string | null>(readStoredKey());

export const useKioskAuth = () => {
  const setKioskKey = (key: string) => {
    try {
      globalThis.localStorage?.setItem(KIOSK_KEY_STORAGE_KEY, key);
      kioskKeyRef.value = key;
    } catch (e) {
      console.error('Failed to persist kiosk key', e);
    }
  };

  const clearKioskKey = () => {
    try {
      globalThis.localStorage?.removeItem(KIOSK_KEY_STORAGE_KEY);
    } catch {
      // ignore
    }
    kioskKeyRef.value = null;
  };

  const hasKioskKey = () => kioskKeyRef.value !== null;

  return {
    kioskKey: readonly(kioskKeyRef),
    setKioskKey,
    clearKioskKey,
    hasKioskKey,
  };
};
